import React, { createContext, useState, useEffect } from "react"
import Cookies from "js-cookie"

export const AuthContext = createContext({
  authUser: null,
  setAuthUser: () => {},
})

export const AuthProvider = ({ children }) => {
  const [authUser, setAuthUser] = useState(null)

  useEffect(() => {
    const raw = Cookies.get("auth")
    if (raw) {
      try {
        const parsed = JSON.parse(raw)
        setAuthUser(parsed)
      } catch (err) {
        console.error("Failed to parse auth cookie:", err)
        setAuthUser(null)
      }
    }
  }, [])

  return (
    <AuthContext.Provider value={{ authUser, setAuthUser }}>
      {children}
    </AuthContext.Provider>
  )
}
